import factory from '../../../props/factory.js';

export default (state = {}, action) =>
{
  return (action.payload ? Object.assign({}, state, action.payload) : state);
};
